import { debugLog, type PlacementId } from '@schibsted-nmp/advertising-shared';

/** Fired when the on-screen percentage of the ad slot changes. */
export function onSlotVisibilityChanged(
  event: googletag.events.SlotVisibilityChangedEvent
) {
  const placementId = event.slot.getSlotElementId() as PlacementId;

  debugLog(`PlacementId: ${placementId}: slotVisibilityChanged event:`, event);
}
